import { Activity } from './activity';

export interface ProcessExecutionStatus {
  currentActivitiesHierarchyDeepestToUp?: Activity[];
  currentUserTaskId?: string;
  executedActivities?: Activity[];
  processInstanceId?: string;
  userSelectedElement?: string;
}
